export const StakeIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 2.5L8 14.5M8 14.5L4 10.5M8 14.5L12 10.5" stroke="white" />
      <path opacity="0.5" d="M1 14H4L5 15H1V14Z" fill="white" />
      <path opacity="0.5" d="M12 14H15V15H11L12 14Z" fill="white" />
    </svg>
  )
}
